import React, { Component } from 'react';
import { Row, Col } from 'antd';
import moment from 'moment';
import 'moment-timezone';
import _ from 'lodash';
import CarouselComponent from '../../../../CommonComponents/Carousel/CarouselComponent';
import TabsComponent from './components/TabsComponent/TabsComponent';
import BalanceCards from '../../../../CommonComponents/BalanceCards/BalanceCards';
import DashboardSummary from './components/DashboardSummary/DashboardSummary';
import TaxReceipts from './components/TaxReceipts/TaxReceipts';
import CompletedContributions from './components/CompletedContributions/CompletedContributions';
import DownloadContributions from './components/DownloadContributions/DownloadContributions';
import { getPrimaryAccount } from '../../../../utils/sessionUtil';
import { startDate, initiateTracking } from '../../../../utils/commonUtil';
import {
  fetchContributionDashboardData,
  fetchLazyData,
  restoreData,
} from './actions';
import BreadcrumbComponent from '../../../../CommonComponents/Breadcrumb/Breadcrumb';
import Preloader from '../../../../CommonComponents/Preloader/Preloader';
import {
  FixedWidth,
  SemiDarkerDivider,
  TabFooter,
  NotifyText,
} from '../../../../CommonComponents/commonStyles';
import {
  renderDashboardFixGrid,
  renderDescriptionGrid,
  renderAmountGrid1,
  renderContributionsDateGrid,
} from '../../../../utils/cardGrid';
import {
  renderContributionTitleGrid,
  renderContributionDateGrid,
  renderContributionFixGrid,
  renderContributionNameGrid,
  renderUserNameFixGrid,
  renderShareFixGrid,
  renderDashboardTypeFixGrid,
  renderContributionsSettledDateGrid,
} from './utils';
import { disabledValidator, disabledText } from './utils';
import { connect } from 'react-redux';
import { getContributionApi } from './config';
import {
  MarginBottom,
  ContributionMargin,
  ContributionHead,
  DateNow,
  MarginWrapper,
  ContributionsDashBoardBody,
  CommonCardContributions,
  ContributionGreyBackgroundSection,
  HeadActivity,
  ActivityText,
  ChartData,
  DateNowIn,
} from './styles';
import BOTChart from './components/ContributionChart/ContributionChart';
import ToJS from './HOC/toJS';
import { todayDate } from '../../../../utils/commonUtil';
import { selectHeader } from '../../../../actions/globalActions';
import {
  ContentProvider,
  Types,
} from '../../../../CommonComponents/ContentMessages';
import PropTypes from 'prop-types';
import {
  GeneralButton,
  TooltipWrapper,
} from '../../../../CommonComponents/Commons/commonComponents';
import { contributionsDashboardStates } from './selectors';

export function filterReceipts(receipts) {
  if (receipts.length) {
    let filteredArray = null;
    filteredArray = receipts.filter((receipt, index) => {
      if (
        receipt.name.split('-')[0] === 'Tax Substantiation Letter ' ||
        receipt.name.split('-')[0] === '* Tax Substantiation Letter '
      ) {
        receipt.id = receipt.name + index;
        return true;
      }
      return false;
    });
    return filteredArray;
  }
  return [];
}

class ContributionsDashBoard extends Component {
  state = {
    contributionsData: [],
    contributionsDataAll: [],
  };
  completedContribRef = React.createRef();
  title = 'Contributions Overview';
  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.requestData(getContributionApi());
  }

  pageLoaded() {
    window.scrollTo(0, 0);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.accountID != nextProps.accountID) {
      this.props.restoreDefaults();
      this.props.requestData(getContributionApi());
    }

    if (!nextProps.isLoadingContributions) {
      this.setContributionsData(nextProps);
    }

    if (!nextProps.isAllContributionLoading) {
      this.setContributionsAllData(nextProps);
    }
  }

  setContributionsData(data) {
    var oneYearData = data.contributionsData;
    this.setState({
      contributionsData: oneYearData,
    });
  }

  setContributionsAllData(data) {
    var fiveYearData = data.allContributionsData;
    this.setState({
      contributionsDataAll: fiveYearData,
    });
  }

  scrollEventHandler = (e, type) => {
    if (this.props.isLazyLoading === false) {
      var elem = e.target;
      if (
        Math.ceil(elem.scrollHeight) - Math.ceil(elem.scrollTop) <=
        elem.clientHeight
      ) {
        if (
          type === 'Pending Contributions' &&
          this.props.pendingDataAvailable
        ) {
          this.props.getLazyData({
            metaData: [
              {
                method: 'POST',
                url: `/donor-portal/api/contribution/${
                  getPrimaryAccount().userId
                }/findByAccountIdStartDateEndDateAndType`,
                page: 'contributionsDashboard',
                data: {
                  accountId: `${getPrimaryAccount().userId}`,
                  startDateStr: `${startDate(90)}`,
                  endDateStr: todayDate(),
                  type: 'PENDING',
                  pageSize: this.props.pendingPagination,
                },
              },
            ],
          });
        } else if (
          type === 'Completed Contributions' &&
          this.props.completedDataAvailable
        ) {
          this.props.getLazyData({
            metaData: [
              {
                method: 'POST',
                url: `/donor-portal/api/contribution/${
                  getPrimaryAccount().userId
                }/findByAccountIdStartDateEndDateAndType`,
                page: 'contributionsDashboard',
                data: {
                  accountId: `${getPrimaryAccount().userId}`,
                  startDateStr: `${startDate(90)}`,
                  endDateStr: todayDate(),
                  type: 'COMPLETED',
                  pageSize: this.props.completedPagination,
                },
              },
            ],
          });
        }
      }
    }
  };

  goToPage = (pathName, selectedHeader) => {
    selectedHeader && this.props.selectHeader(selectedHeader);
    this.props.history.push(pathName);
  };

  goFromCardsToPage = (e, pathName, query, selectedHeader) => {
    e.preventDefault();
    selectedHeader && this.props.selectHeader(selectedHeader);
    if (query) {
      this.props.history.push(pathName + query);
    } else {
      this.props.history.push(pathName);
    }
  };

  goToContribution = (data) => {
    selectHeader('Contribution Activity');
    this.props.history.push({
      pathname: '/contributions/activity/view',
      state: {
        transactionId: data.txnId,
        status: data.status,
        giftId: data.giftId,
      },
    });
  };

  analyticsHandler = (eventType, action, name) => {
    initiateTracking(
      eventType,
      this.title,
      action ? action : '',
      name ? name : ''
    );
  };

  render() {
    const {
      isLazyLoading,
      pendingContributions,
      isLoadingPendingContributions,
      completedContributions,
      isLoadingCompletedContributions,
      taxReceipts,
      isLoadingTaxReceipts,
      accIsLoading,
      accData,
      ytdData,
      ytdIsLoading,
    } = this.props;
    let primaryAccount = getPrimaryAccount();
    if (
      typeof accData != 'null' &&
      typeof accData === 'object' &&
      primaryAccount
    )
      accData.roleAccess = primaryAccount.role.access;

    if (accIsLoading) return <Preloader />;

    const BalanceCardsConfiguration = [
      {
        heading: 'Current Balance',
        balance: accData.currentBalance,
        text:
          'Balance in your donor-advised fund after the previous day’s trading cycle is complete',
        buttonName: 'View Account summary',
        url: '/',
        pageName: 'ACCOUNT SUMMARY',
      },
      {
        heading: 'Available Balance',
        balance: accData.availableBalance,
        text:
          'Your current balance, minus any pending grants, pending exchanges, or assets invested in TIFF',
        url: '/my-account/transaction-summary',
        buttonName: 'View Transaction summary',
        pageName: 'Transaction Summary',
      },
      {
        heading: 'Contributions YTD',
        balance: ytdData && ytdData.contributionYtd,
        text: 'Completed contribution totals year-to-date',
        url: '/contributions/activity',
        buttonName: 'View Contribution Activity',
        pageName: 'Contribution Activity',
      },
    ];
    const tabConfig = function destObj(data, index, clicked, item) {
      return [
        {
          config: [
            {
              name: 'txnId',
              type: 'TitleGrid',
              gridWidth: '100',
              mobileGridWidth: '100',
              render: renderContributionTitleGrid({
                data,
                each: 'txnId',
                label: 'Transaction Id',
                index: index,
                comingSoon: false,
                handleTitleClick: () => clicked(data, item),
              }),
              noBorderBottom: true,
              ptop: false,
              pbottom: false,
            },
            {
              name: 'description',
              gridWidth: '100',
              mobileGridWidth: '100',
              render: renderDescriptionGrid({
                data,
                each: 'description',
                label: 'Description',
                index: index,
              }),
              noBorderBottom: true,
              ptop: false,
              pbottom: false,
            },
            {
              name: 'userName',
              type: 'Data',
              gridWidth: '30',
              mobileGridWidth: '50',
              render: renderUserNameFixGrid({
                data,
                each: 'userName',
                label: 'Entered By',
                index: index,
              }),
              noBorderBottom: true,
              ptop: false,
              pbottom: false,
            },
            {
              name: 'enteredDate',
              gridWidth: '30',
              mobileGridWidth: '50',
              render: renderContributionsDateGrid({
                data,
                each: 'enteredDate',
                label: 'Entered date',
              }),
              ptop: false,
              pbottom: true,
            },
            {
              name: 'ReceivedDate',
              type: 'Date',
              gridWidth: '30',
              mobileGridWidth: '50',
              render: renderContributionsDateGrid({
                data,
                each: 'receivedDate',
                label: 'Received date',
              }),
              ptop: false,
              pbottom: true,
            },
            {
              name: 'NumberOfShares',
              gridWidth: '30',
              mobileGridWidth: '50',
              render: renderShareFixGrid({
                data,
                each: 'noOfShares',
                label: 'Number of shares',
              }),
              ptop: false,
              pbottom: true,
            },
            {
              name: 'type',
              gridWidth: '30',
              mobileGridWidth: '50',
              render: renderDashboardTypeFixGrid({
                data,
                each: 'type',
                label: 'Contribution Type',
              }),
              ptop: false,
              pbottom: true,
            },
            {
              name: 'Amount',
              gridWidth: '30',
              mobileGridWidth: '50',
              render: renderAmountGrid1({
                data,
                each: 'amount',
                label: 'Amount',
              }),
              ptop: false,
              pbottom: true,
            },
            {
              name: 'status',
              gridWidth: '100',
              mobileGridWidth: '100',
              render: renderDashboardFixGrid({
                data,
                each: 'status',
                label: 'Status',
              }),
              ptop: false,
              pbottom: true,
            },
          ],
        },
        {
          config: [
            {
              name: 'txnId',
              type: 'TitleGrid',
              gridWidth: '100',
              mobileGridWidth: '100',
              render: renderContributionTitleGrid({
                data,
                each: 'txnId',
                label: 'Transaction Id',
                index: index,
                comingSoon: false,
                handleTitleClick: () => clicked(data, item),
              }),
              noBorderBottom: true,
              ptop: false,
              pbottom: false,
            },
            {
              name: 'description',
              gridWidth: '100',
              mobileGridWidth: '100',
              render: renderDescriptionGrid({
                data,
                each: 'description',
                label: 'Description',
                index: index,
              }),
              noBorderBottom: true,
              ptop: false,
              pbottom: false,
            },
            {
              name: 'userName',
              type: 'Data',
              gridWidth: '50',
              mobileGridWidth: '50',
              render: renderUserNameFixGrid({
                data,
                each: 'userName',
                label: 'Entered By',
                index: index,
              }),
              noBorderBottom: true,
              ptop: false,
              pbottom: false,
            },
            {
              name: 'enteredDate',
              type: 'Date',
              gridWidth: '50',
              mobileGridWidth: '50',
              render: renderContributionsDateGrid({
                data,
                each: 'enteredDate',
                label: 'Entered date',
              }),
              ptop: false,
              pbottom: true,
            },
            {
              name: 'ReceivedDate',
              type: 'Date',
              gridWidth: '50',
              mobileGridWidth: '50',
              render: renderContributionsDateGrid({
                data,
                each: 'receivedDate',
                label: 'Received date',
              }),
              ptop: false,
              pbottom: true,
            },
            {
              name: 'NumberOfShares',
              gridWidth: '50',
              mobileGridWidth: '50',
              render: renderShareFixGrid({
                data,
                each: 'noOfShares',
                label: 'Number of shares',
              }),
              ptop: false,
              pbottom: true,
            },
            {
              name: 'type',
              gridWidth: '50',
              mobileGridWidth: '50',
              render: renderDashboardTypeFixGrid({
                data,
                each: 'type',
                label: 'Contribution Type',
              }),
              ptop: false,
              pbottom: true,
            },
            {
              name: 'Amount',
              gridWidth: '50',
              mobileGridWidth: '50',
              render: renderAmountGrid1({
                data,
                each: 'amount',
                label: 'Amount',
              }),
              ptop: false,
              pbottom: true,
            },
            {
              name: 'status',
              gridWidth: '50',
              mobileGridWidth: '50',
              render: renderDashboardFixGrid({
                data,
                each: 'status',
                label: 'Status',
              }),
              ptop: false,
              pbottom: true,
            },
            {
              name: 'Settled Date',
              gridWidth: '50',
              mobileGridWidth: '50',
              render: renderContributionsSettledDateGrid({
                data,
                each: 'settledDate',
                label: 'Settled Date',
              }),
              ptop: false,
              pbottom: true,
            },
          ],
        },
      ];
    };

    const completedCardConfig = function destObj(data, index, clicked, item) {
      return [
        {
          config: [
            {
              name: 'txnId',
              type: 'TitleGrid',
              gridWidth: '100',
              render: renderContributionTitleGrid({
                data,
                each: 'txnId',
                label: 'Transaction Id',
                index: index,
                comingSoon: false,
                handleTitleClick: () => clicked(data, item),
              }),
              noBorderBottom: true,
              ptop: false,
              pbottom: false,
            },
            {
              name: 'userName',
              type: 'Data',
              gridWidth: '50',
              render: renderContributionNameGrid({
                data,
                each: 'userNaME',
                label: 'Entered by',
                index: index,
              }),
              noBorderBottom: true,
              ptop: false,
              pbottom: false,
            },
            {
              name: 'enteredDate',
              gridWidth: '50',
              render: renderContributionDateGrid({
                data,
                each: 'enteredDate',
                label: 'Entered date',
              }),
              ptop: false,
              pbottom: true,
            },
            {
              name: 'ReceivedDate',
              type: 'Date',
              gridWidth: '50',
              render: renderContributionDateGrid({
                data,
                each: 'receivedDate',
                label: 'Received date',
              }),
              ptop: false,
              pbottom: true,
            },
            {
              name: 'noOfShares',
              gridWidth: '50',
              render: renderContributionFixGrid({
                data,
                each: 'noOfShares',
                label: 'Number of shares',
              }),
              ptop: false,
              pbottom: true,
            },
            {
              name: 'type',
              gridWidth: '50',
              render: renderContributionFixGrid({
                data,
                each: 'type',
                label: 'Type',
              }),
              ptop: false,
              pbottom: true,
            },
            {
              name: 'Amount',
              gridWidth: '50',
              render: renderContributionFixGrid({
                data,
                each: 'amount',
                label: 'Amount',
              }),
              ptop: false,
              pbottom: true,
            },
            {
              name: 'status',
              gridWidth: '50',
              render: renderContributionFixGrid({
                data,
                each: 'status',
                label: 'Status',
              }),
              ptop: false,
              pbottom: true,
            },
          ],
        },
      ];
    };

    const tabPanes = [
      {
        title: 'Pending Contributions',
        key: 1,
        destComponent: 'card',
        mobComponent: 'card',
        data: pendingContributions,
        isLoading: isLoadingPendingContributions,
        text: 'No pending contributions have been made in the last 90 days.',
      },
      {
        title: 'Completed Contributions',
        key: 2,
        destComponent: 'card',
        mobComponent: 'card',
        data: completedContributions,
        isLoading: isLoadingCompletedContributions,
        text: 'No completed contributions have been made in the last 90 days.',
      },
    ];
    this.breadcrumbRoutes = () => {
      return [
        {
          routeName: 'Home',
          path: '/',
        },
        {
          routeName: 'Contributions Overview',
          path: '',
        },
      ];
    };
    return (
      <ContentProvider
        types={[Types.PAGE_TITLE_DESCRIPTION]}
        pages={['Contributions Overview']}
      >
        <ContributionsDashBoardBody className='Analytics_contributionsDashboard'>
          <FixedWidth>
            <BreadcrumbComponent breadcrumbRoutes={this.breadcrumbRoutes()} />
          </FixedWidth>
          <DashboardSummary accData={accData} />
          <ContributionGreyBackgroundSection>
            <FixedWidth>
              <Row>
                {ytdIsLoading === false ? (
                  <Col md={{ span: '8' }}>
                    <BalanceCards
                      clicked={(e, pathName, query, selectedHeader) =>
                        this.goFromCardsToPage(
                          e,
                          pathName,
                          query,
                          selectedHeader
                        )
                      }
                      grantsDashboard={true}
                      config={BalanceCardsConfiguration}
                    />
                    <TooltipWrapper
                      text={disabledText(accData)}
                      placement={
                        window.screen.availWidth >= 320 &&
                        425 >= window.screen.availWidth
                          ? 'top'
                          : 'right'
                      }
                      element={
                        <div className='expanded-width'>
                          <GeneralButton
                            data-test='contributionsDashboardMakeAContributionClick'
                            text='MAKE A CONTRIBUTION'
                            type='primary'
                            disabled={disabledValidator(accData)}
                            width='100%'
                            mobWidth='100%'
                            onClick={() =>
                              this.goToPage(
                                '/contributions/make-a-contribution',
                                'Make a contribution'
                              )
                            }
                          />
                        </div>
                      }
                    />
                  </Col>
                ) : (
                  <Col md={{ span: '8' }}>
                    {' '}
                    <Preloader />{' '}
                  </Col>
                )}
                <Col md={{ span: '16' }} className='mt-xs-20'>
                  <ContributionMargin>
                    <CommonCardContributions>
                      <TabsComponent
                        handleTabAnalytics={(eventType, action, tabName) =>
                          this.analyticsHandler(eventType, action, tabName)
                        }
                        dashboard={true}
                        tabPanes={tabPanes}
                        tabConfig={tabConfig}
                        containerHeight={
                          this.props.carouselData.length !== 0
                            ? '264px'
                            : 998 <= window.screen.availWidth &&
                              window.screen.availWidth <= 1024
                            ? '533px'
                            : 768 <= window.screen.availWidth &&
                              window.screen.availWidth <= 997
                            ? '520px'
                            : '524px'
                        }
                        contributionDashboard={true}
                        isLazyLoading={isLazyLoading}
                        scrolled={(event, type) =>
                          this.scrollEventHandler(event, type)
                        }
                        xscroll={false}
                        transactionClicked={(item) =>
                          this.goToContribution(item)
                        }
                      />
                      <SemiDarkerDivider className='my0' />
                      <TabFooter>
                        <GeneralButton
                          type='tertiary'
                          styling='ml3 mt1 mb1'
                          text='View Contribution Activity'
                          onClick={() =>
                            this.goToPage(
                              '/contributions/activity',
                              'Contribution Activity'
                            )
                          }
                          tabNavigation={true}
                        />
                        <NotifyText>
                          Transactions displayed above are from last 90 days
                        </NotifyText>
                      </TabFooter>
                    </CommonCardContributions>
                  </ContributionMargin>
                  <CarouselComponent isFull />
                </Col>
              </Row>
            </FixedWidth>
          </ContributionGreyBackgroundSection>
          <FixedWidth>
            <MarginWrapper>
              <DateNow>Timeline</DateNow>
              <HeadActivity>Contribution Activity</HeadActivity>
              <ActivityText>
                This section allows you to review your contribution activity at
                a glance. First, select the date range that you would like to
                review and the chart will display your contribution activity
                over time.{' '}
              </ActivityText>
              <Row>
                {this.props.isContributionLoading === true ||
                (this.state.contributionsData.length === 0 &&
                  this.props.isAllContributionLoading === true) ? (
                  <div>
                    <div className='grants-dashboard noDataPlacement chart-no-data'>
                      <div className='loader-position'>
                        <div>
                          <img
                            src={require('../../../../assets/icons/loader.gif')}
                            className='mr-icon'
                            alt='loader'
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ) : this.props.isContributionLoading === false &&
                  this.props.isAllContributionLoading === false ? (
                  this.state.contributionsData.length === 0 &&
                  this.state.contributionsDataAll.length === 0 ? (
                    <div>
                      <div className='grants-dashboard noDataPlacement chart-no-data'>
                        <ChartData>
                          You currently have no contribution activity
                        </ChartData>
                      </div>
                    </div>
                  ) : (
                    <BOTChart
                      handleFilterAnalytics={(eventType, action, tabName) =>
                        this.analyticsHandler(eventType, action, tabName)
                      }
                      isAllContributionLoading={
                        this.props.isAllContributionLoading
                      }
                      data_y5={this.props.data_y5}
                      data_all_y5={this.props.data_all_y5}
                      data={this.state.contributionsData}
                      dataAll={this.state.contributionsDataAll}
                      botStatusText={this.props.botStatusText}
                      additionalDetails={this.props.establishedDate}
                    />
                  )
                ) : (
                  <BOTChart
                    handleFilterAnalytics={(eventType, action, tabName) =>
                      this.analyticsHandler(eventType, action, tabName)
                    }
                    isAllContributionLoading={
                      this.props.isAllContributionLoading
                    }
                    data_y5={this.props.data_y5}
                    data_all_y5={this.props.data_all_y5}
                    data={this.state.contributionsData}
                    dataAll={this.state.contributionsDataAll}
                    botStatusText={this.props.botStatusText}
                    additionalDetails={this.props.establishedDate}
                  />
                )}
              </Row>
            </MarginWrapper>
          </FixedWidth>
          <FixedWidth>
            <MarginBottom>
              <div>
                {this.props.selectedCompletedContributionsError ? (
                  <p>Cannot Fetch Contributions</p>
                ) : this.props.isLoadingContributions ? (
                  <div className='grants-dashboard noDataPlacement chart-no-data'>
                    <div className='loader-position'>
                      <div>
                        <img
                          src={require('../../../../assets/icons/loader.gif')}
                          className='mr-icon'
                          alt='loader'
                        />
                      </div>
                    </div>
                  </div>
                ) : this.props.selectedCompletedContributions &&
                  this.props.isLoadingContributions === false &&
                  this.props.showData ? (
                  <>
                    <DateNowIn className='mt-50'>
                      {moment(
                        this.props.selectedCompletedContributions[0].tradeDate
                      ).format('LL')}
                    </DateNowIn>
                    <ContributionHead className='mb-20'>
                      Completed Contributions
                    </ContributionHead>
                    <div ref={this.completedContribRef} />
                    <CompletedContributions
                      completedContributions={
                        this.props.selectedCompletedContributions
                      }
                      completedContribRef={this.completedContribRef}
                      transactionClicked={(item) => this.goToContribution(item)}
                      config={completedCardConfig}
                      error={this.props.isContributionsError}
                    />
                  </>
                ) : null}
              </div>
            </MarginBottom>
          </FixedWidth>
          <ContributionGreyBackgroundSection>
            <FixedWidth>
              <Row gutter={20}>
                <Col md={{ span: '16' }} xs={{ span: '24' }}>
                  <TaxReceipts
                    handleViewAnalytics={(eventType, action, tabName) =>
                      this.analyticsHandler(eventType, action, tabName)
                    }
                    isLoading={isLoadingTaxReceipts}
                    taxReceipts={filterReceipts(taxReceipts)}
                  />
                </Col>
                <Col md={{ span: '8' }} xs={{ span: '24' }}>
                  {this.props.valueYourContributionsIsLoading === false ? (
                    <DownloadContributions
                      handleDownloadAnalytics={(eventType, action, tabName) =>
                        this.analyticsHandler(eventType, action, tabName)
                      }
                      link={this.props.valueYourContributions}
                    />
                  ) : (
                    <Preloader />
                  )}
                </Col>
              </Row>
            </FixedWidth>
          </ContributionGreyBackgroundSection>
        </ContributionsDashBoardBody>
      </ContentProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  ...contributionsDashboardStates(state.toJS()),
});

export const mapDispatchToProps = (dispatch) => ({
  requestData: (data) => dispatch(fetchContributionDashboardData(data)),
  getLazyData: (data) => dispatch(fetchLazyData(data)),
  restoreDefaults: () => dispatch(restoreData()),
  selectHeader: (data) => dispatch(selectHeader(data)),
});

export default ToJS(
  connect(mapStateToProps, mapDispatchToProps)(ContributionsDashBoard)
);

ContributionsDashBoard.propTypes = {
  accIsLoading: PropTypes.bool,
  ytdIsLoading: PropTypes.bool,
  valueYourContributionsIsLoading: PropTypes.bool,
  showData: PropTypes.bool,
  pendingDataAvailable: PropTypes.bool,
  isLoadingTaxReceipts: PropTypes.bool,
  isLoadingPendingContributions: PropTypes.bool,
  isLoadingContributions: PropTypes.bool,
  isLoadingCompletedContributions: PropTypes.bool,
  isLazyLoading: PropTypes.bool,
  isContributionLoading: PropTypes.bool,
  isAllContributionLoading: PropTypes.bool,
  data_y5: PropTypes.bool,
  data_y3: PropTypes.bool,
  data_all_y5: PropTypes.bool,
  data_all_y3: PropTypes.bool,
  completedDataAvailable: PropTypes.bool,
  ytdData: PropTypes.shape({
    contributionYtd: PropTypes.number,
    grantsYtd: PropTypes.number,
    investmentYtd: PropTypes.number,
  }),
  taxReceipts: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.number,
      id: PropTypes.string,
      link: PropTypes.string,
      name: PropTypes.string,
    })
  ),
  selectHeader: PropTypes.func,
  restoreDefaults: PropTypes.func,
  requestData: PropTypes.func,
  getLazyData: PropTypes.func,
  allContributionsData: PropTypes.arrayOf(
    PropTypes.shape({
      allShares: PropTypes.bool,
      amount: PropTypes.number,
      availableBalance: PropTypes.number,
      currentBalance: PropTypes.number,
      description: PropTypes.string,
      dpUser: PropTypes.string,
      dpUserFirstName: PropTypes.string,
      dpUserLastName: PropTypes.string,
      dpUserMiddleName: PropTypes.string,
      dpUserPrefix: PropTypes.string,
      dpUserSuffix: PropTypes.string,
      enteredDate: PropTypes.number,
      giftId: PropTypes.number,
      isRecurring: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
      noOfShares: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      orderId: 0,
      pendingContribution: PropTypes.bool,
      receivedDate: PropTypes.number,
      reversed: PropTypes.bool,
      settledDate: PropTypes.number,
      status: PropTypes.string,
      tradeDate: PropTypes.number,
      txnId: PropTypes.number,
      type: PropTypes.string,
      userName: PropTypes.string,
      x: PropTypes.number,
      y3: PropTypes.bool,
      y5: PropTypes.bool,
    })
  ),
  contributionsData: PropTypes.arrayOf(
    PropTypes.shape({
      allShares: PropTypes.bool,
      amount: PropTypes.number,
      availableBalance: PropTypes.number,
      currentBalance: PropTypes.number,
      description: PropTypes.string,
      dpUser: PropTypes.string,
      dpUserFirstName: PropTypes.string,
      dpUserLastName: PropTypes.string,
      dpUserMiddleName: PropTypes.string,
      dpUserPrefix: PropTypes.string,
      dpUserSuffix: PropTypes.string,
      enteredDate: PropTypes.number,
      giftId: PropTypes.number,
      isRecurring: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
      noOfShares: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      orderId: 0,
      pendingContribution: PropTypes.bool,
      receivedDate: PropTypes.number,
      reversed: PropTypes.bool,
      settledDate: PropTypes.number,
      status: PropTypes.string,
      tradeDate: PropTypes.number,
      txnId: PropTypes.number,
      type: PropTypes.string,
      userName: PropTypes.string,
      x: PropTypes.number,
      y3: PropTypes.bool,
      y5: PropTypes.bool,
    })
  ),
  botStatusText: PropTypes.string,
  completedContributions: PropTypes.array,
  completedPagination: PropTypes.number,
  establishedDate: PropTypes.object,
  accData: PropTypes.shape({
    accountId: PropTypes.string,
    accountName: PropTypes.string,
    availableBalance: PropTypes.number,
    beginBalance: PropTypes.number,
    contributionYTD: PropTypes.number,
    currentBalance: PropTypes.number,
    dateChanged: PropTypes.number,
    endBalance: PropTypes.number,
    grantsAndContribution: PropTypes.number,
    marketMovement: PropTypes.number,
    roleAccess: PropTypes.string,
    ytdPercentage: PropTypes.number,
    ytdPercentageIncrease: PropTypes.bool,
  }),
};
